import React, { useState,useEffect } from 'react'
import { MemoizedComponent } from '../../../components/Reports/PivotTableModal';
import CustomFormLabel from '../../../components/common/form-label/CustomFormLabel ';
import AsyncDropDown from './AsyncDrodown/AsyncDropDown';
import axios from 'axios';
import { getContactsUrl } from '../../../redux/actions/ContactManagement/Contact';
import { useDispatch } from 'react-redux';
import { ActionType } from '../../../redux/actions/Snackbars';
import { debounce } from 'lodash';
interface IDropdownItem {
    id : number;
    label : string;
    value : string | number;
}
interface ICommonContactDropDownProps{
    addonQuery?:string;
    defaultValue : null | IDropdownItem;
    callback : any;
    title: string;
    defaultOptions?: any[];
    isMulti?:boolean;
    isMandatory?:boolean;
}
const formatData = (data:any=[]) =>{
  return data.map((item: any) => ({
    label: `${item.name},(${item.email})`,
    name: item.name,
    value: item.id,
    id: item.id,
    knownAs: item.knownAs,
    userName: item.userName,
    jobTitle: item.jobTitle,
    email: item.email,
    whatsAppNumber: item.whatsAppNumber,
    company: item.companyName,
    place: item.officeLocation,
    no: item.mobilePhone,
    isVIP: item.isVIP,
    alert: item.alert,
    profilePictureId: item.profilePictureId,
  }));
}
function CommonContactDropDown(props:ICommonContactDropDownProps) {
    const {addonQuery="",defaultValue=null,defaultOptions=[],callback,title,isMulti=false,isMandatory=true} = props;
    const dispatch = useDispatch();
    const promiseOptions = debounce((inputValue: any, callback: any,firstLoad?:boolean) => {
          axios.get(
              `${getContactsUrl}?${inputValue.length > 0 ? "search="+ inputValue + "&" : ""}page=1&count=50&isActive=true${addonQuery}`
            )
            .then((response: any) => {
              const data = response.data;
              console.error("options", data);
              const options = formatData(data)
              callback([...defaultOptions,...options]); // Pass options to the callback
            })
            .catch((error: any) => {
              console.error("Error fetching data:", error);
              callback(defaultOptions); // Pass options to the callback
              dispatch({
                type: ActionType.SNACKBAR,
                payload: {
                  message: `Server Error! Log out and try again`,
                  severity: "error",
                  open: true,
                },
              });
            });
    },150);    
    const [firstSetData,setfirstSetData] = useState<any>(null);
    const [value,setValue] = useState(defaultValue)
    useEffect(()=>{
      loadFirstSet()
    },[])
    useEffect(()=>{
        setValue(defaultValue)
    },[defaultValue])
    const loadFirstSet = debounce(()=>{
      axios.get(
        `${getContactsUrl}?page=1&count=50&isActive=true${addonQuery}`
      )
      .then((response: any) => {
        const options = formatData(response?.data);
        setfirstSetData([...defaultOptions,...options])
      })
    },100)
  return (
      <>
          <CustomFormLabel
              labelName={title}
              isMandotary={isMandatory}
          />
          {firstSetData?.length &&
            <AsyncDropDown
                isMulti = {isMulti}
                promiseOptions={promiseOptions}
                name="primaryContact"
                placeHolder="Search and select a Contact"
                handleChange={(e: any) => {
                  setValue(e);
                  callback(e);
                  //   handleSelectChange(e, "primaryContact");
                  //   handleSelectChangeForFilter(e, "selectedTo");
                    console.log("primary contact", e.email);
                }}
                defaultValue={value}
                defaultOptions={firstSetData}
            />
          }
      </>
  )
}

export default CommonContactDropDown